import Icon from '../components/Icon.vue'

Icon.register({
  'arrows-alt-h': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M377.9 169.9c0-21.4 25.9-32.1 41-17l86.1 86.1c9.4 9.4 9.4 24.6 0 33.9l-86.1 86.1c-15.1 15.1-41 4.4-41-17v-46.1h-243.9v46.1c0 21.4-25.9 32.1-41 17l-86.1-86.1c-9.4-9.4-9.4-24.6 0-33.9l86.1-86.1c15.1-15.1 41-4.4 41 17v46.1h243.9v-46.1z'
      }
    ]
  }
})
